export default __webpack_public_path__ + "static/media/logo-zad.35830385.png";